<template>
  <div>
    <h1 class="page-header">{{ $t('thesis.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'thesis-create' })"
            >
              {{ $t('add_new') }}
            </ts-button>
          </div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input
              v-model="search"
              :placeholder="$t('Search')"
              style="width: 300px"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="scrollable">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                class="mr-2 text-primary"
                v-tooltip="
                  $t('school.academic.operation.classOperation.student')
                "
                @click.prevent="showStudentList(record)"
              >
                <span class="badge badge-primary">{{
                  record.thesis_registration_members.length
                }}</span>
              </a>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.registration_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.thesis_topic ? record.thesis_topic.topic_name_kh : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.thesis_topic ? record.thesis_topic.topic_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.start_date }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.end_date }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.academic_class ? record.academic_class.class_name : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.teacher ? record.teacher.full_name_en : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.presentation_date }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                class="mr-2 text-primary"
                v-tooltip="$t('thesis.committee')"
                @click.prevent="showCommitteeList(record)"
              >
                <span class="badge badge-primary">{{
                  record.committees.length
                }}</span>
              </a>
            </td>
            <td class="ts-whitespace-no-wrap">
              {{
                record.created_by
                  ? record.created_by.employee
                    ? record.created_by.employee.name_en
                    : record.created_by.loginname
                  : ''
              }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.created_date }}</td>
            <td class="text-left ts-whitespace-no-wrap">
              <a
                href="#"
                class="mr-2 text-primary"
                v-tooltip="$t('thesis.uploadFile')"
                @click.prevent="showFormAttachedFile(record)"
              >
                <i class="fas fa-file-upload"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('view')"
                class="mr-2 text-info"
                @click.prevent="showFormListView(record)"
                v-if="record.attachment_files.length > 0"
              >
                <i class="fas fa-eye"></i>
              </a>
              <a
                href="#"
                class="mr-2 text-primary"
                v-tooltip="$t('thesis.committee')"
                @click.prevent="showFormCommitte(record)"
              >
                <i class="fas fa-users"></i>
              </a>
              <a
                href="#"
                title="edit"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                title="delete"
                class="text-danger mr-2"
                @click.prevent="destroy(record.thesis_reg_id)"
              >
                <i class="fas fa-trash"></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15 ts-mt-3">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-modal
        v-model="show_student_list"
        centered
        @ok="() => (show_student_list = false)"
        :zIndex="1020"
        :cancelText="$t('cancel')"
        :okText="$t('ok')"
        :footer="null"
        width="60%"
      >
        <student-list :thesis_registration_members="student_id_list" />
      </a-modal>
      <a-modal
        v-model="show_committee_List"
        centered
        @ok="() => (show_committee_List = false)"
        :zIndex="1020"
        :cancelText="$t('cancel')"
        :okText="$t('ok')"
        :footer="null"
        width="50%"
      >
        <committee-list :committees="committee" />
      </a-modal>
      <a-modal
        v-model="show_list_view"
        centered
        @ok="() => (show_list_view = false)"
        :zIndex="1020"
        :cancelText="$t('cancel')"
        :okText="$t('ok')"
        :footer="null"
        width="70%"
      >
        <list-view
          ref="list_view"
          @fetchPhoto="getCurrentFile"
          @fetchNav="$emit('fetchNavi')"
        />
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import FormCommitte from './components/form-committe.vue'
import FormAttachedFile from './components/attached-file.vue'
import StudentList from './components/view-student-lists.vue'
import listView from './components/list-view.vue'
import CommitteeList from './components/committee-list.vue'
export default {
  name: 'thesis',
  components: {
    FormCommitte,
    FormAttachedFile,
    StudentList,
    listView,
    CommitteeList
  },
  data () {
    return {
      loading: false,
      show_form: false,
      show_student_list: false,
      view_photo: false,
      loadingPhoto: false,
      show_committee_List: false,
      student_id_list: [],
      view_record: null,
      show_list_view: false,
      item_type: null,
      thesis_reg_id: null,
      committee: [],
      model: {
        student_id_list: [],
        committee: []
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    ...mapState('thesis', ['resources', 'pagination', 'files']),
    search: {
      get () {
        return this.$store.state.thesis.search
      },
      set (newVal) {
        this.$store.commit('thesis/SET_SEARCH', newVal)
        this.$store.commit('thesis/RESET_CURRENT_PAGE')
      }
    },

    columns: function () {
      return [
        {
          name: this.$t('thesis.studentCount')
        },
        {
          name: this.$t('thesis.registrationDate')
        },
        {
          name: this.$t('thesis.topicKH')
        },
        {
          name: this.$t('thesis.topicEn')
        },
        {
          name: this.$t('thesis.startDate')
        },
        {
          name: this.$t('thesis.endDate')
        },
        {
          name: this.$t('thesis.subjactClass')
        },
        {
          name: this.$t('thesis.teachterEn')
        },
        {
          name: this.$t('thesis.presentationDate')
        },
        {
          name: this.$t('thesis.comitteeCount')
        },
        {
          name: this.$t('thesis.createdBy')
        },
        {
          name: this.$t('thesis.createdDate')
        },
        { name: this.$t('actions'), style: 'width:7%; text-align:left' }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('thesis/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    async getCurrentFile () {
      this.loadingPhoto = true
      this.thesis_reg_id = this.view_record.thesis_reg_id
      await this.$store
        .dispatch('thesis/getFile', this.thesis_reg_id)
        .then(() => (this.loadingPhoto = false))
        .finally(() => {
          this.loadingPhoto = false
        })
    },
    edit (record) {
      this.$store.commit('thesis/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'thesis-edit',
        params: { id: record.thesis_reg_id }
      })
    },
    showFormCommitte (record) {
      this.$store.commit('thesis/SET_EDIT_DATA', record)
      this.$modal.show(
        FormCommitte,
        {
          params: { id: record.thesis_reg_id }
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    showFormAttachedFile (record) {
      this.$store.commit('thesis/SET_EDIT_DATA', record)

      this.$modal.show(
        FormAttachedFile,
        {
          params: { id: record.thesis_reg_id }
        },
        {
          height: 'auto',
          width: '980px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    async destroy (id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('thesis/delete', id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    },
    showStudentList (record) {
      this.show_student_list = true
      this.student_id_list = record.thesis_registration_members
    },
    async showFormListView (items) {
      this.show_list_view = true
      this.view_record = items
      await this.getCurrentFile()
    },
    showCommitteeList (record) {
      this.show_committee_List = true
      this.committee = record.committees
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
<style>
.scrollable {
  overflow-y: scroll;
}
</style>
